import React from 'react';
import { valueForKeyPath as v } from '../utils.jsx';

class UserPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  contentManagerClick() {
    this.props.setAdminContent(false);
  }

  cmAdminClick() {
    this.props.setAdminContent(true);
  }

  render() {
    let superadmin_menu;
    if (this.props.user_is_cs_admin) {
      superadmin_menu = (
        <span>
          &nbsp;|&nbsp;
          <a
            href="javascript:void(0);"
            onClick={this.contentManagerClick.bind(this)}
          >
            {this.props.admin_content ? (
              'Správa obsahu'
            ) : (
              <strong>Správa obsahu</strong>
            )}
          </a>
          &nbsp;|&nbsp;
          <a href="javascript:void(0);" onClick={this.cmAdminClick.bind(this)}>
            {this.props.admin_content ? (
              <strong>Administrácia</strong>
            ) : (
              'Administrácia'
            )}
          </a>
        </span>
      );
    }
    return (
      <div id="header" className="panel panel-default">
        <div className="panel-body">
          <div className="row">
            <div className="col-md-4">
              <strong>{this.props.appname}</strong>
              {superadmin_menu}
            </div>
            <div className="col-md-4 text-center">
              <strong>{this.props.contentspace_info.name}</strong>
            </div>
            <div className="col-md-4 text-right">
              {v(this.props.user, 'display_name', 'User')}
              &nbsp;|&nbsp;
              <a href="javascript:void(0)" onClick={this.props.logout}>
                Odhlásiť sa
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
UserPanel.defaultProps = {
  user: {},
  appname: 'DEFAULT APP NAME',
};

export default UserPanel;



// WEBPACK FOOTER //
// ./src/js/app/UserPanel.jsx